module.exports = __webpack_public_path__ + "static/media/close-circle.80e9d388.svg";